//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: String,

    value: Boolean,

    width: {
      type: Number,
      default: 560,
    },
  },

  methods: {
    input(value) {
      this.$emit("input", value)
    },
  },
}
